import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLock, FiArrowLeft } from 'react-icons/fi';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <FiLock className="text-6xl text-orange-500 mb-4" />
      <h1 className="text-3xl font-bold text-text-light dark:text-text-dark mb-2">
        Access Denied
      </h1>
      <p className="text-lg text-text-light/80 dark:text-text-dark/80 mb-6">
        You do not have permission to access this page.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <button
          onClick={() => navigate(-1)} // Go back to the previous page
          className="inline-flex items-center justify-center px-6 py-3 bg-secondary-light dark:bg-secondary-dark text-text-light dark:text-text-dark rounded-md transition duration-150 ease-in-out font-semibold hover:brightness-95 dark:hover:brightness-110"
        >
          <FiArrowLeft className="mr-2" />
          Go Back
        </button>
        <Link 
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 bg-accent-light hover:bg-accent-dark dark:bg-accent-dark dark:hover:bg-accent-light text-white dark:text-black rounded-md transition duration-150 ease-in-out font-semibold"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage; 